import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import App from './app/App';
import '@styles';
import React, { Suspense } from 'react';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import { CsrfTokenProvider } from './app/contexts/CSRFTokenContext';
import { IdleTimeoutProvider } from './app/contexts/IdleTimeoutContext';

const root = createRoot(document.getElementById('root'));

root.render(
    <Suspense>
        <HashRouter>
            <IdleTimeoutProvider>
                <CsrfTokenProvider><App /></CsrfTokenProvider>
            </IdleTimeoutProvider>
        </HashRouter>
    </Suspense>,
);
